<template>
  <div class="page no-margin">
    <div v-if="getAttribute('loading') || !getAttribute('dates').length" class="spinner-container">
      <div class="spinner"></div>
    </div>
    <template v-else>
      <MSelect v-model="filter.country" label="Country:" placeholder="All" col="4" :options="getAttribute('countries')" />
      <MSelect
        v-model="filter.date"
        label="Client invoice payment dates:"
        placeholder="Select a date"
        col="8"
        :options="getAttribute('dates')"
      />
      <div class="cards-container">
        <div v-for="item in getAttribute('clientInvoicePayments')" :key="item.id">
          <InvoicePayment
            :desc="item.id"
            :invoice-payment="item"
            invoice-type="client"
            :invoice-links="{
              PDF: `${baseApiUrl}/clients/${item.client_payment_org_id}/invoices/${item.id}/pdf`,
              EXCEL: `${baseApiUrl}/clients/${item.client_payment_org_id}/invoices/${item.id}/excel`,
            }"
            :on-approvement-change="changeApprovement"
            :on-recalculation="recalculate"
          />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { config } from '@/lib/helpers/config.helpers'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import MSelect from '../../components/metapic/inputs/MSelect.vue'
import InvoicePayment from '../../components/InvoicePayment.vue'
export default {
  components: {
    MSelect,
    InvoicePayment,
  },
  data() {
    return { baseApiUrl: config.apiBaseUrl }
  },
  computed: {
    ...mapGetters('clientInvoicePayments/list', ['filter', 'getAttribute']),
  },
  watch: {
    filter: {
      handler() {
        this.search()
      },
      deep: true,
    },
  },
  created() {
    this.getDates()
    this.search()
  },
  methods: {
    ...mapActions('clientInvoicePayments/list', ['getDates', 'search', 'changeApprovement', 'recalculate']),
    ...mapMutations('clientInvoicePayments/list', ['update']),
  },
}
</script>

<style scoped>
.cards-container {
  margin-top: 90px;
  width: 99%;
}

.spinner-container {
  position: absolute !important;
  top: 5%;
  left: 0;
}
</style>
